
import React, { useState } from "react";
import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";
import { vcsList } from "../../data/vcData";
import "./InnovationIncubation.css";

const coordinator = {
  name: "Dr. G. Renuka",
  designation: "Innovation & Incubation Coordinator",
  department: "Rayalaseema University, Kurnool",
  image: "/businessmanagement/Renuka.JPG",
};

const galleryImages = [
  {
    image: "/inovation/banner1.jpeg",
    title: "Innovation Activities",
  },
  {
    image: "/inovation/gallary1.jpeg",
    title: "Innovation Activities",
  },
  
  {
    image: "/inovation/gallary3.jpeg",
    title: "Entrepreneurship Development",
  },
  {
    image: "/inovation/gallary4.jpeg",
    title: "Research and Innovation",
  },
  {
    image: "/inovation/gallary5.jpeg",
    title: "Startup Ideas and Prototypes",
  },
  {
    image: "/inovation/gallary6.jpeg",
    title: "Student Collaboration",
  },
  {
    image: "/inovation/gallary7.jpeg",
    title: "Student Collaboration",
  },
  {
    image: "/inovation/gallary8.jpeg",
    title: "Student Collaboration",
  },
  {
    image: "/inovation/gallary9.jpeg",
    title: "Student Collaboration",
  },
];

function SectionHeading({ title, subtitle }) {
  return (
    <div className="innovation-heading">
      <span className="innovation-heading-label">
        RAYALASEEMA UNIVERSITY
      </span>
      <h2>{title}</h2>
      {subtitle && <p>{subtitle}</p>}
      <div className="innovation-heading-line" />
    </div>
  );
}

export default function InnovationIncubation() {
  const currentVC =
    vcsList?.find((vc) => vc.id === 9) ||
    vcsList?.[vcsList.length - 1];

  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <>
      <Navbar />

      <main className="innovation-page">
        {/* Banner */}
        <section className="innovation-banner">
          <img
            className="innovation-banner-image"
            src="/inovation/banner2.jpeg"
            alt="Innovation and Incubation Centre"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />

          <div className="innovation-banner-overlay">
            <div className="innovation-banner-content">
              <span className="innovation-banner-tag">
                RESEARCH • CREATIVITY • ENTREPRENEURSHIP
              </span>
              <h1>Innovation &amp; Incubation Centre</h1>
              <p>
                Encouraging innovative ideas, supporting entrepreneurship,
                and transforming research into real-world solutions.
              </p>
              <a href="#innovation-about" className="innovation-banner-button">
                Explore the Centre <span>→</span>
              </a>
            </div>
          </div>
        </section>

        {/* Introduction */}
        <section
          id="innovation-about"
          className="innovation-about innovation-container"
        >
          <SectionHeading
            title="About the Centre"
            subtitle="Building a culture of innovation at Rayalaseema University"
          />

          <div className="innovation-about-grid">
            <div className="innovation-about-icon">
              <span>💡</span>
              <h3>Ideas into Impact</h3>
              <p>Inspire. Innovate. Incubate.</p>
            </div>

            <div className="innovation-about-content">
              <p>
                The Innovation &amp; Incubation Centre at Rayalaseema
                University, Kurnool, aims to encourage creativity,
                research, entrepreneurship, and technology-driven
                solutions among students, research scholars, and faculty
                members. The centre provides a platform to explore new
                ideas, develop prototypes, work collaboratively, and
                identify opportunities to transform innovative concepts
                into practical applications.
              </p>
              <p>
                Through innovation activities, mentoring, project
                demonstrations, interdisciplinary collaboration, and
                entrepreneurship awareness, the centre seeks to
                strengthen the university's innovation ecosystem and
                encourage solutions to real-world challenges.
              </p>
            </div>
          </div>
        </section>

        {/* Objectives */}
        <section className="innovation-objectives">
          <div className="innovation-container">
            {/* <SectionHeading
              title="Our Focus Areas"
              subtitle="Supporting ideas from concept to implementation"
            /> */}

            <div className="innovation-objective-grid">
              <article className="innovation-objective-card">
                <span className="innovation-objective-icon">💡</span>
                <h3>Innovation</h3>
                <p>
                  Encourage creative thinking, new ideas, and innovative
                  approaches to academic and societal challenges.
                </p>
              </article>

              <article className="innovation-objective-card">
                <span className="innovation-objective-icon">🔬</span>
                <h3>Research &amp; Prototyping</h3>
                <p>
                  Support research-based projects, experimentation,
                  proof-of-concept development, and demonstrations.
                </p>
              </article>

              <article className="innovation-objective-card">
                <span className="innovation-objective-icon">🚀</span>
                <h3>Startup &amp; Entrepreneurship</h3>
                <p>
                  Promote entrepreneurial thinking and help students
                  explore the potential of their ideas.
                </p>
              </article>

              <article className="innovation-objective-card">
                <span className="innovation-objective-icon">🤝</span>
                <h3>Collaboration</h3>
                <p>
                  Encourage partnerships, interdisciplinary teamwork,
                  mentoring, and industry interaction.
                </p>
              </article>
            </div>
          </div>
        </section>

        {/* Vice-Chancellor Message */}
        <section className="innovation-vc-section">
          <div className="innovation-container">
            {/* <SectionHeading
              title="Message from the Vice-Chancellor"
              subtitle="A vision for creativity, research and entrepreneurship"
            /> */}

            <div className="innovation-vc-card">
              <div className="innovation-vc-photo">
                <img
                  src="/person/vicechancellor2.JPG"
                  alt={currentVC?.name || "Vice-Chancellor"}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src =
                      "/person/vicechancellor1.JPG";
                  }}
                />
              </div>

              <div className="innovation-vc-content">
                <span className="innovation-vc-label">
                  Hon'ble Vice-Chancellor
                </span>

                <h3>
                  {currentVC?.name || "Hon'ble Vice-Chancellor"}
                </h3>

                <p>
                  Innovation and entrepreneurship are important drivers
                  of educational excellence and social progress.
                  Universities must provide an environment where students
                  and researchers can think creatively, explore new
                  technologies, and transform knowledge into meaningful
                  solutions.
                </p>

                <p>
                  Rayalaseema University encourages its students,
                  research scholars, and faculty members to pursue
                  innovative ideas, undertake research-oriented projects,
                  collaborate across disciplines, and develop solutions
                  that address the needs of society. The Innovation
                  &amp; Incubation Centre can play a valuable role in
                  nurturing this spirit and preparing students for
                  emerging opportunities.
                </p>

                <div className="innovation-vc-signature">
                  {currentVC?.name || "Hon'ble Vice-Chancellor"}
                  <span>Rayalaseema University, Kurnool</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Coordinator Profile */}
        <section className="innovation-coordinator-section">
          <div className="innovation-container">
            {/* <SectionHeading
              title="Center Coordinator"
              subtitle="Guidance and support for innovation initiatives"
            /> */}

            <article className="innovation-coordinator-card">
              <div className="innovation-coordinator-photo">
                <img
                  src={coordinator.image}
                  alt={coordinator.name}
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    e.currentTarget.parentElement.classList.add(
                      "innovation-coordinator-photo-missing"
                    );
                  }}
                />
                <span className="innovation-coordinator-fallback">
                  IC
                </span>
              </div>

              <div className="innovation-coordinator-info">
                <span className="innovation-vc-label">
                  CENTRE COORDINATOR
                </span>
                <h3>{coordinator.name}</h3>
                <p>{coordinator.designation}</p>
                <p>{coordinator.department}</p>
                <p className="innovation-coordinator-note">
                  The coordinator supports innovation activities,
                  student projects, research collaboration, and
                  entrepreneurship initiatives.
                </p>
              </div>
            </article>
          </div>
        </section>

        {/* Gallery */}
        <section className="innovation-gallery-section">
          <div className="innovation-container">
            <SectionHeading
              title="Innovation Gallery"
              subtitle="Activities, projects, workshops and achievements"
            />

            <div className="innovation-gallery-grid">
              {galleryImages.map((item) => (
                <button
                  type="button"
                  className="innovation-gallery-item"
                  key={item.image}
                  onClick={() => setSelectedImage(item)}
                  aria-label={`View ${item.title}`}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                      e.currentTarget.parentElement.classList.add(
                        "innovation-gallery-missing"
                      );
                    }}
                  />
                  {/* <span className="innovation-gallery-fallback">
                    <span>📷</span>
                    {item.title}
                  </span>
                  <span className="innovation-gallery-caption">
                    {item.title}
                  </span> */}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Image lightbox */}
        {selectedImage && (
          <div
            className="innovation-lightbox"
            role="dialog"
            aria-modal="true"
            aria-label={selectedImage.title}
            onClick={() => setSelectedImage(null)}
          >
            <button
              type="button"
              className="innovation-lightbox-close"
              aria-label="Close image"
              onClick={() => setSelectedImage(null)}
            >
              &times;
            </button>

            <div
              className="innovation-lightbox-content"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={selectedImage.image}
                alt={selectedImage.title}
              />
              {/* <p>{selectedImage.title}</p> */}
            </div>
          </div>
        )}
      </main>

      <Footer />
    </>
  );
}
